import { render } from "./ContentsTitleButton.vue?vue&type=template&id=0352bd38&scoped=true"
import script from "./ContentsTitleButton.vue?vue&type=script&lang=js"
export * from "./ContentsTitleButton.vue?vue&type=script&lang=js"

import "./ContentsTitleButton.vue?vue&type=style&index=0&id=0352bd38&scoped=true&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R7\\07j\\ht\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0352bd38"]])

export default __exports__